module.exports = __webpack_public_path__ + "Roboto-Medium.7b225d4d9324ee54ce6d.woff";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2demo/src/assets/fonts/Roboto-Medium.woff
// module id = ../../../../../src/assets/fonts/Roboto-Medium.woff
// module chunks = main